import { useTranslation } from "react-i18next";
import { IUserApiClient } from "../clients/userApiClient"
import { useInjection } from "../di/ioc-provider"
import { TYPES } from "../di/types"
import DcDataTable, { DcTableHeader, TableFilterState } from "./dcTable";
import React from "react";
import { ConnectedApp, ForeignInvoice } from "../clients/dossierApiClient";
import { defaultFilter } from "../pages/DossierPage";
import GeneralDialog from "./generalDialog";
import SearchField from "./searchField";
import { Button, Checkbox, Grid, TableCell, TableRow, Typography } from "@mui/material";
import { sortOnFilter } from "../helpers";
import { SearchOutlined } from "@mui/icons-material";
import { useImmer } from "use-immer";
import { LoadButton } from "./loadButton";
import teamleaderLogo from "../assets/TeamleaderIcon.jpg"
export interface ISearchInvoicesViaTeamleader {
    foreignCompanyId: string;
    type: string;
    onSelectInvoices: (invoices: ForeignInvoice[]) => void;
}

export const SearchInvoicesViaTeamleader = (props: ISearchInvoicesViaTeamleader) => {

    const _userClient = useInjection<IUserApiClient>(TYPES.IUserClient);
    const [t] = useTranslation("common");

    const headers = [
        { name: t("general.invoiceSelected"), id: "invoiceSelected" },
        { name: t("general.invoiceNumber"), id: "invoiceNumber" },
    ] as DcTableHeader[]
    const [loading, setLoading] = React.useState(false);
    const [invoices, setInvoices] = React.useState<ForeignInvoice[]>([])
    const [filterState, setFilter] = React.useState<TableFilterState>(defaultFilter);
    const [selectedInvoices, setSelectedInvoices] = useImmer<ForeignInvoice[]>([]);
    const [openDialog, setOpenDialog] = React.useState(false);
    const fetchData = () => {
        setLoading(true);
        _userClient.getInvoices({
            skip: filterState.skip,
            take: filterState.take,
            sortColumn: filterState.sortColumn,
            sortOrder: filterState.sortOrder,
            payload: { search: filterState.search, foreignCompanyId: props.foreignCompanyId,type: props.type, app: ConnectedApp.Teamleader }
        })
            .then((res) => {

                setInvoices(res.data.data);
            }).catch(() => { }).finally(() => { setLoading(false) })
    }
    React.useEffect(() => {
        if (openDialog)
            fetchData();
    }, [filterState, openDialog])

    return <>
        <GeneralDialog isLoading={loading} open={openDialog} onClose={() => { setOpenDialog(false) }}>
            <Grid container spacing={2} style={{ paddingBottom: "4px" }}>
                <Grid item><img src={teamleaderLogo}></img></Grid>
                <Grid item style={{
                    position: "relative",
                    top: "12px"
                }}> <Typography color={"#00b2b2"}> {t("general.searchTlInvoiceTitle")}</Typography></Grid>
            </Grid>
            <SearchField
                onChange={() => { }}
                id="search-departments"
                className="full-width"
                debouncedWaitTime={500}
                label={t("general.searchTlInvoices")}
                onDebouncedSearch={(val) => {
                    var copy = { ...filterState };
                    copy.search = val;
                    setFilter(copy);
                }} />
            <DcDataTable
            
                headers={headers}
                onFilterClicked={(el) => { setFilter(sortOnFilter(filterState, el)) }}
                filters={filterState}>
                {invoices.map((el) => {
                    return <>
                        <TableRow className="clickable" key={el.id} hover onClick={() => { }}>
                            <TableCell><Checkbox onChange={(ev) => {
                                if (ev.target.checked) {
                                    setSelectedInvoices((draft) => {
                                        draft.push(el);
                                    })
                                } else {
                                    setSelectedInvoices((draft) => {
                                        return draft.filter(w => w.id != el.id);
                                    })
                                }
                            }} checked={selectedInvoices.find(w => w.id == el.id) != null}></Checkbox></TableCell>
                            <TableCell>{el.invoiceNumber}</TableCell>
                        </TableRow>
                    </>
                })}
            </DcDataTable>
            <LoadButton
                color={"primary"}
                style={{ width: "100%", marginTop: "14px" }}
                isLoading={false}
                variant="contained"
                buttonText={t("general.addTlInvoicesBtn")}
                onClick={() => { props.onSelectInvoices(selectedInvoices); setOpenDialog(false) }}>

            </LoadButton>
        </GeneralDialog>
        <Button style={{ color: "#00b2b2" }} onClick={() => { setOpenDialog(true) }} startIcon={<img src={teamleaderLogo}></img>}>{t("general.SearchInvoiceWTeamleader")}</Button>

    </>
}